<template>
  <div id="clientManage">
    <div class="title">
      <img src="../../assets/image/icon_kh@2x.png" style="width:34px" alt />
      <h3>客户管理</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="clientActive" @tab-click="handleClick">
        <!-- 个人 -->
        <el-tab-pane label="个人" name="1">
          <!-- 搜索条件行 -->
          <div class="searchInfoRow">
            <el-form ref="form" :model="addClassForm" label-position="left">
              <div class="firstRow">
                <el-form-item label-width="30%" label="创建时间">
                  <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="startChange"
                    v-model="searchInfo.startDate"
                    type="date"
                    align="center"
                    class="SearchDate"
                    placeholder="开始时间"
                    :picker-options="pickerOptionsStart"
                  ></el-date-picker>
                  <span style="font-size:16px;margin:0 20px;line-height: 48px;">至</span>
                  <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="endChange"
                    v-model="searchInfo.endDate"
                    type="date"
                    class="SearchDate"
                    placeholder="选择时间"
                    :picker-options="pickerOptionsEnd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label-width="40%" label="客户姓名/电话/编号：">
                  <el-input v-model="searchInfo.userName" placeholder="姓名/电话/编号"></el-input>
                </el-form-item>
              </div>
              <div class="SearchFormRow firstRow">
                <el-form-item label-width="12%" label="项目类型">
                  <ul class="projectType">
                    <li>
                      <span
                        @click="projectTypeSelect('全部')"
                        :class="searchInfo.projectType==='全部' ? 'liActive':''"
                      >全部</span>
                    </li>
                    <li v-for="item in projectTypeList" :key="item.project_type_id">
                      <span
                        @click="projectTypeSelect(item.project_type_id)"
                        :class="searchInfo.projectType===item.project_type_id ? 'liActive':''"
                      >{{item.project_type_name}}</span>
                    </li>
                  </ul>
                </el-form-item>
              </div>
              <div class="SearchFormRow firstRow">
                <el-form-item label-width="12%" label="客户状态">
                  <ul class="projectType">
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('全部')"
                        :class="searchInfo.clientStatus==='全部'?'liActive':''"
                      >全部</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('0')"
                        :class="searchInfo.clientStatus==='0'?'liActive':''"
                      >无效</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('1')"
                        :class="searchInfo.clientStatus==='1'?'liActive':''"
                      >有意向</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('2')"
                        :class="searchInfo.clientStatus==='2'?'liActive':''"
                      >跟进中</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('3')"
                        :class="searchInfo.clientStatus==='3'?'liActive':''"
                      >正式客户</span>
                    </li>
                  </ul>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <!-- 操作行 -->
          <div class="searchRow">
            <div class="leftCol btnCol">
              <p>
                已选择
                <span>{{SelectNum}}</span> 项
              </p>
              <!-- <el-button class="creat" style="background-color:#40A0F2;">编辑参与人员</el-button>
              <el-button class="creat" style="background-color:#40A0F2;">修改项目类型</el-button>
              <el-button class="creat" style="background-color:#40A0F2;">转移客户</el-button>
              <el-button class="creat" style="background-color:#40A0F2;">一键转为正式客户</el-button>-->
            </div>
            <div class="btnCol">
              <el-button class="search" @click="handleSearch">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2; width:170px"
                @click="addUserClick"
              >新建客户</el-button>
            </div>
          </div>
          <!-- 表格 -->
          <el-table
            :header-cell-style="{background:'#40A0F2', padding:'18px 0',color:'#fff',fontSize:'16px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'12px 0',fontWeight:'400'}"
            :data="tableData"
            stripe
            style="width: 100%; margin-top:10px"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="55"></el-table-column>
            <el-table-column
              prop="id"
              :show-overflow-tooltip="true"
              width="65"
              align="center"
              label="编号"
            ></el-table-column>
            <el-table-column
              prop="customer_name"
              :show-overflow-tooltip="true"
              width="200"
              align="left"
              label="客户名称"
            ></el-table-column>
            <el-table-column
              prop="address"
              :show-overflow-tooltip="true"
              align="center"
              width="120"
              label="联系人/电话"
            >
              <template slot-scope="scope">
                <div style="width:100%" v-if="scope.row.phone || scope.row.name">
                  <p
                    style="width:100%;text-align:left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                  >{{scope.row.name}}</p>
                  <p
                    style="width:100%;text-align:left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                  >{{scope.row.phone}}</p>
                </div>
                <p style="width:100%;text-align:left;" v-else>---</p>
              </template>
            </el-table-column>
            <el-table-column prop="wx" :show-overflow-tooltip="true" align="center" label="微信">
              <template slot-scope="scope">
                <p
                  v-if="scope.row.wx"
                  style="width:100%;text-align:center;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                >{{scope.row.wx}}</p>
                <p v-else>---</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="project_type"
              :show-overflow-tooltip="true"
              align="center"
              label="项目类型"
            ></el-table-column>
            <el-table-column prop="address" :show-overflow-tooltip="true" align="center" label="状态">
              <template slot-scope="scope">
                <p v-if="scope.row.state==='0'">无效</p>
                <p v-if="scope.row.state==='1'">有意向</p>
                <p v-if="scope.row.state==='2'">跟进中</p>
                <p v-if="scope.row.state==='3'">正式客户</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="member.nickname"
              :show-overflow-tooltip="true"
              align="center"
              label="负责人"
            ></el-table-column>
            <el-table-column
              prop="add_time"
              :show-overflow-tooltip="true"
              align="center"
              label="创建时间"
            ></el-table-column>
            <el-table-column prop="address" width="280" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEditUser(scope.row)" class="tableBtn">编辑</el-button>
                <el-button
                  @click="handleRemoveUser(scope.row)"
                  :disabled="isAdmin==0 ? false : true"
                  class="tableBtn"
                  style="border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 公司 -->
        <el-tab-pane label="公司" name="2">
          <!-- 搜索条件行 -->
          <div class="searchInfoRow">
            <el-form ref="form" :model="addClassForm" label-position="left">
              <div class="firstRow">
                <el-form-item label-width="30%" label="创建时间">
                  <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="startChange"
                    v-model="searchInfo.startDate"
                    type="date"
                    align="center"
                    class="SearchDate"
                    placeholder="开始时间"
                    :picker-options="pickerOptionsStart"
                  ></el-date-picker>
                  <span style="font-size:16px;margin:0 20px;line-height: 48px;">至</span>
                  <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="endChange"
                    v-model="searchInfo.endDate"
                    type="date"
                    class="SearchDate"
                    placeholder="选择时间"
                    :picker-options="pickerOptionsEnd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label-width="40%" label="客户姓名/电话/编号：">
                  <el-input v-model="searchInfo.userName" placeholder="姓名/电话/编号"></el-input>
                </el-form-item>
              </div>
              <div class="SearchFormRow firstRow">
                <el-form-item label-width="12%" label="项目类型">
                  <ul class="projectType">
                    <li>
                      <span
                        @click="projectTypeSelect('全部')"
                        :class="searchInfo.projectType==='全部' ? 'liActive':''"
                      >全部</span>
                    </li>
                    <li v-for="item in projectTypeList" :key="item.project_type_id">
                      <span
                        @click="projectTypeSelect(item.project_type_id)"
                        :class="searchInfo.projectType===item.project_type_id ? 'liActive':''"
                      >{{item.project_type_name}}</span>
                    </li>
                  </ul>
                </el-form-item>
              </div>
              <div class="SearchFormRow firstRow">
                <el-form-item label-width="12%" label="客户状态">
                  <ul class="projectType">
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('全部')"
                        :class="searchInfo.clientStatus==='全部'?'liActive':''"
                      >全部</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('0')"
                        :class="searchInfo.clientStatus==='0'?'liActive':''"
                      >无效</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('1')"
                        :class="searchInfo.clientStatus==='1'?'liActive':''"
                      >有意向</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('2')"
                        :class="searchInfo.clientStatus==='2'?'liActive':''"
                      >跟进中</span>
                    </li>
                    <li style="width:16.7%">
                      <span
                        @click="clientStatusSelect('3')"
                        :class="searchInfo.clientStatus==='3'?'liActive':''"
                      >正式客户</span>
                    </li>
                  </ul>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <!-- 操作行 -->
          <div class="searchRow">
            <div class="leftCol btnCol">
              <p>
                已选择
                <span>{{SelectNum}}</span> 项
              </p>
              <el-button class="creat" style="background-color:#40A0F2;">编辑参与人员</el-button>
              <el-button class="creat" style="background-color:#40A0F2;">修改项目类型</el-button>
              <el-button class="creat" style="background-color:#40A0F2;">转移客户</el-button>
              <el-button class="creat" style="background-color:#40A0F2;">一键转为正式客户</el-button>
            </div>
            <div class="btnCol">
              <el-button @click="handleSearch" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2; width:170px"
                @click="addUserClick"
              >新建客户</el-button>
            </div>
          </div>
          <!-- 表格 -->
          <el-table
            :header-cell-style="{background:'#40A0F2', padding:'18px 0',color:'#fff',fontSize:'16px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'12px 0',fontWeight:'400'}"
            :data="tableData"
            stripe
            style="width: 100%; margin-top:20px"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="55"></el-table-column>
            <el-table-column
              prop="id"
              :show-overflow-tooltip="true"
              width="65"
              align="center"
              label="编号"
            ></el-table-column>
            <el-table-column
              prop="customer_name"
              :show-overflow-tooltip="true"
              width="200"
              align="left"
              label="客户名称"
            ></el-table-column>
            <el-table-column
              prop="address"
              :show-overflow-tooltip="true"
              align="center"
              width="120"
              label="联系人/电话"
            >
              <template slot-scope="scope">
                <div style="width:100%" v-if="scope.row.phone || scope.row.name">
                  <p
                    style="width:100%;text-align:left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                  >{{scope.row.name}}</p>
                  <p
                    style="width:100%;text-align:left;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                  >{{scope.row.phone}}</p>
                </div>
                <p style="width:100%;text-align:left;" v-else>---</p>
              </template>
            </el-table-column>
            <el-table-column prop="wx" :show-overflow-tooltip="true" align="center" label="微信">
              <template slot-scope="scope">
                <p
                  v-if="scope.row.wx"
                  style="width:100%;text-align:center;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                >{{scope.row.wx}}</p>
                <p v-else>---</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="project_type"
              :show-overflow-tooltip="true"
              align="center"
              label="项目类型"
            ></el-table-column>
            <el-table-column prop="address" :show-overflow-tooltip="true" align="center" label="状态">
              <template slot-scope="scope">
                <p v-if="scope.row.state==='0'">无效</p>
                <p v-if="scope.row.state==='1'">有意向</p>
                <p v-if="scope.row.state==='2'">跟进中</p>
                <p v-if="scope.row.state==='3'">正式客户</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="member.nickname"
              :show-overflow-tooltip="true"
              align="center"
              label="负责人"
            ></el-table-column>
            <el-table-column
              prop="add_time"
              :show-overflow-tooltip="true"
              align="center"
              label="创建时间"
            ></el-table-column>
            <el-table-column prop="address" width="280" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEditUser(scope.row)" class="tableBtn">编辑</el-button>
                <el-button
                  @click="handleRemoveUser(scope.row)"
                  class="tableBtn"
                  style="border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose"
      class="addClientDia"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span
          class="title-name"
          v-if="showForm==='2'"
          style="color:#128BF1;margin-right:5px"
        >{{editName}}-</span>
        <span class="title-age" v-if="showForm==='1'">新增客户信息</span>
        <span class="title-age" v-if="showForm==='2'">编辑客户信息</span>
      </div>
      <div class="diaContainer">
        <!-- 新建客户表单 -->
        <el-form ref="form" :model="addUserForm" v-if="showForm==='1'" label-width="30%">
          <div class="diaForm_box">
            <div class="diaFormTitle">客户信息</div>
            <el-form-item label="客户名称">
              <el-input placeholder="请输入客户名称" v-model="addUserForm.customer_name"></el-input>
            </el-form-item>
            <el-form-item class="labelFormItem" label="客户类型" style="margin-bottom:10px">
              <el-radio-group v-model="addUserForm.type">
                <el-radio label="0">普通客户</el-radio>
                <el-radio label="1">高级客户</el-radio>
                <el-radio label="2">VIP客户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="labelFormItem" label="客户性质">
              <el-radio-group v-model="addUserForm.is_company">
                <el-radio label="0">个人</el-radio>
                <el-radio label="1">公司</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="客户来源">
              <el-input placeholder="请输入客户名称" v-model="addUserForm.source"></el-input>
            </el-form-item>
            <el-form-item label="客户描述" style="margin-bottom:10px">
              <el-input placeholder="请输入客户名称" type="textarea" v-model="addUserForm.describe"></el-input>
            </el-form-item>
          </div>
          <div class="diaForm_box">
            <div class="diaFormTitle">业务信息</div>
            <el-form-item class="labelFormItem" label="业务类型" style="margin-bottom:10px">
              <!-- <el-radio-group class="ProjectType heightAutoC" v-model="addUserForm.project_type">
                <el-radio
                  :label="item.project_type_id"
                  v-for="item in projectTypeList"
                  :key="item.project_type_name"
                >{{item.project_type_name}}</el-radio>
              </el-radio-group>-->
              <el-checkbox-group class="ProjectType heightAutoC" v-model="addUserForm.project_type">
                <el-checkbox
                  :label="item.project_type_id"
                  v-for="item in projectTypeList"
                  :key="item.project_type_name"
                >{{item.project_type_name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="diaForm_box">
            <div class="diaFormTitle1" style="display:felx;justify-content:space-between;width:86%">
              <span class style="width:auto">联系人信息</span>
              <el-button @click="Addcontacts" class="AddLianxiRen">新增联系人</el-button>
            </div>
            <div class="contactsBox">
              <div
                v-for="(item,index) in contactsList"
                style="margin-top:30px"
                :class="index===0?'firstItemNeedMargin':''"
              >
                <div class="inputTwoRow">
                  <el-form-item label="联系人" label-width="40%" style="width:50%">
                    <el-input placeholder="联系人" v-model="item.name"></el-input>
                  </el-form-item>
                  <el-form-item label="电话" label-width="40%" style="width:50%">
                    <el-input placeholder="电话" v-model="item.phone"></el-input>
                  </el-form-item>
                </div>
                <div class="inputTwoRow">
                  <el-form-item label="职位" label-width="40%" style="width:50%">
                    <el-input placeholder="职位" v-model="item.charege"></el-input>
                  </el-form-item>
                  <el-form-item label="微信" label-width="40%" style="width:50%">
                    <el-input placeholder="微信" v-model="item.wx"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="diaForm_box">
            <div class="diaFormTitle">其他信息</div>
            <el-form-item label="备注" style="margin-bottom:0px">
              <el-input placeholder="备注" type="textarea" v-model="addUserForm.remark"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <!-- 编辑客户表单 -->
        <el-form ref="form" :model="editUserForm" v-if="showForm==='2'" label-width="30%">
          <div class="diaForm_box">
            <div class="diaFormTitle">客户信息</div>
            <el-form-item label="客户名称">
              <el-input placeholder="请输入客户名称" v-model="editUserForm.customer_name"></el-input>
            </el-form-item>
            <el-form-item class="labelFormItem" label="客户类型" style="margin-bottom:10px">
              <el-radio-group v-model="editUserForm.type">
                <el-radio label="0">普通客户</el-radio>
                <el-radio label="1">高级客户</el-radio>
                <el-radio label="2">VIP客户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="labelFormItem" label="客户性质">
              <el-radio-group v-model="editUserForm.is_company">
                <el-radio label="0">个人</el-radio>
                <el-radio label="1">公司</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="客户来源">
              <el-input placeholder="请输入客户名称" v-model="editUserForm.source"></el-input>
            </el-form-item>
            <el-form-item label="客户描述" style="margin-bottom:10px">
              <el-input placeholder="请输入客户名称" type="textarea" v-model="editUserForm.describe"></el-input>
            </el-form-item>
          </div>
          <div class="diaForm_box">
            <div class="diaFormTitle">业务信息</div>
            <el-form-item class="labelFormItem" label="业务类型" style="margin-bottom:10px">
              <el-checkbox-group
                class="ProjectType heightAutoC"
                v-model="editUserForm.project_type_id"
              >
                <el-checkbox
                  :label="item.project_type_id"
                  v-for="item in projectTypeList"
                  :key="item.project_type_name"
                >{{item.project_type_name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="diaForm_box">
            <div class="diaFormTitle1" style="display:felx;justify-content:space-between;width:86%">
              <span class style="width:auto">联系人信息</span>
              <el-button @click="AddcontactsEdit" class="AddLianxiRen">新增联系人</el-button>
            </div>
            <div class="contactsBox">
              <div
                v-for="(item,index) in contactsEditList"
                style="margin-top:30px"
                :class="index===0?'firstItemNeedMargin':''"
              >
                <div class="inputTwoRow">
                  <el-form-item label="联系人" label-width="40%" style="width:50%">
                    <el-input placeholder="联系人" v-model="item.name"></el-input>
                  </el-form-item>
                  <el-form-item label="电话" label-width="40%" style="width:50%">
                    <el-input placeholder="电话" v-model="item.phone"></el-input>
                  </el-form-item>
                </div>
                <div class="inputTwoRow">
                  <el-form-item label="职位" label-width="40%" style="width:50%">
                    <el-input placeholder="职位" v-model="item.charege"></el-input>
                  </el-form-item>
                  <el-form-item label="微信" label-width="40%" style="width:50%">
                    <el-input placeholder="微信" v-model="item.wx"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="diaForm_box">
            <div class="diaFormTitle">其他信息</div>
            <el-form-item label="备注" style="margin-bottom:0px">
              <el-input placeholder="备注" type="textarea" v-model="editUserForm.remark"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="showForm==='1'" @click="handleAddSubmit">确 定</el-button>
        <el-button type="primary" v-if="showForm==='2'" @click="handleEditUserSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdmin: '',
      is_company: '0',
      editName: '',
      editId: '',
      contactsSum: 1,
      contactsList: [
        {
          name: '',
          phone: '',
          charege: '',
          wx: '',
        },
      ],
      contactsEditList: [],
      token: '',
      cache_department_id: '',
      tiemID: null,
      timeDou: 100,
      member_id: '',
      company_id: '',
      SelectNum: 0,
      showForm: '',
      clientActive: '1',
      searchInfo1: '',
      currentUserPage: 1,
      userPageSize: 10,
      userTotal: 0,
      dialogVisible: false,
      searchInfo: {
        startDate: '',
        endDate: '',
        userName: '',
        projectType: '全部',
        clientStatus: '全部',
      },
      editUserForm: {},
      // 新增成员
      addUserForm: {
        customer_name: '',
        project_type: [],
        type: '0',
        is_company: '0',
        source: '',
        describe: '',
        remark: '',
        contacts: '',
      },
      // 新增部门表单
      addClassForm: {
        name: '',
        chargePeople: '',
        remark: '',
      },
      // 新增部门表单
      addMessageForm: {
        name: '',
        remark: '',
      },
      projectTypeList: [],
      // searchInfo.endDate
      // searchInfo.startDate
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.searchInfo.endDate) {
            //如果开始时间不为空，则结束时间大于开始时间,且大于当前时间
            return (
              new Date(this.searchInfo.endDate).getTime() < time.getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6 //开始时间不选时，结束时间最大值大于等于当天
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.searchInfo.startDate) {
            //如果开始时间不为空，则结束时间大于开始时间,且大于当前时间
            return (
              new Date(this.searchInfo.startDate).getTime() > time.getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6 //开始时间不选时，结束时间最大值大于等于当天
          }
        },
      },

      tableData: [],
    }
  },
  methods: {
    handleSearch() {
      this.currentUserPage = 1
      this.getCustomerList()
    },
    Addcontacts() {
      // this.contactsSum++
      this.contactsList.push({
        name: '',
        phone: '',
        charege: '',
        wx: '',
      })
    },
    AddcontactsEdit() {
      // this.contactsSum++
      this.contactsEditList.push({
        name: '',
        phone: '',
        charege: '',
        wx: '',
      })
    },
    handleSelectionChange(selection) {
      this.SelectNum = selection.length
      let arr = []
      selection.forEach((item) => {
        arr.push(item.id)
      })
      this.ids = [...arr]
    },
    // *新增提交
    async handleAddSubmit() {
      if (this.addUserForm.customer_name.trim().length <= 0)
        return this.$message.error('请填写客户名称')
      if (this.addUserForm.project_type.length <= 0)
        return this.$message.error('请选择业务类型')
      if (!this.addUserForm.type) return this.$message.error('请选择客户类型')
      if (!this.addUserForm.is_company)
        return this.$message.error('请选择客户性质')
      let arr = []
      this.contactsList.forEach((item, index) => {
        if (
          !item.name &&
          !item.phone &&
          !item.charege &&
          !item.wx &&
          index != 0
        )
          return
        arr.push(
          item.name + '-' + item.phone + '-' + item.charege + '-' + item.wx
        )
      })
      this.addUserForm.contacts = JSON.stringify(arr)
      // return console.log(this.addUserForm)
      let project_typeStr = ''
      this.addUserForm.project_type.forEach((item) => {
        project_typeStr += item + ','
      })
      project_typeStr = project_typeStr.slice(0, project_typeStr.length - 1)
      // return console.log('this.addUserForm.project_type', project_typeStr)

      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)

        param.append('company_id', this.company_id)
        param.append('customer_name', this.addUserForm.customer_name)
        param.append('project_type', project_typeStr)
        param.append('type', this.addUserForm.type)
        param.append('is_company', this.addUserForm.is_company)
        param.append('source', this.addUserForm.source)
        param.append('describe', this.addUserForm.describe)
        param.append('remark', this.addUserForm.remark)
        param.append('contacts', this.addUserForm.contacts)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Customer/add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getCustomerList()
      }, this.timeDou)
    },
    // *获取客户列表
    async getCustomerList() {
      if (this.searchInfo.endDate == null) {
        this.searchInfo.endDate = ''
      }
      if (this.searchInfo.startDate == null) {
        this.searchInfo.startDate = ''
      }
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('is_company', this.is_company)
      // 开始时间
      param.append('date_start', this.searchInfo.startDate)
      // 结束时间
      param.append('date_end', this.searchInfo.endDate)
      // 模糊查询词
      param.append('search', this.searchInfo.userName)
      param.append('p', 1)
      param.append('p_count', 1000)
      if (this.searchInfo.projectType != '全部') {
        // project_type
        param.append('project_type', this.searchInfo.projectType)
      }
      if (this.searchInfo.clientStatus != '全部') {
        // 客户性质
        param.append('state', this.searchInfo.clientStatus)
      }

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Customer/index',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.tableData = res.datas.listInfo
      // :disabled="isAdmin==0 ? false : true"
      this.isAdmin = res.datas.admin_state
      this.tableData.forEach((item) => {
        if (item.contacts.length >= 1) {
          item.name = item.contacts[0].split('-')[0]
          item.phone = item.contacts[0].split('-')[1]
          item.charege = item.contacts[0].split('-')[2]
          item.vx = item.contacts[0].split('-')[3]
        }
      })

      console.log('个人客户列表', this.tableData)
    },
    // *获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      if (this.projectTypeList.length == 0) {
        this.$message.error('请先在管理-项目设置-内设置项目类型')
      }
      console.log('项目类型列表', this.projectTypeList)
    },
    // 点击新增成员
    addUserClick() {
      this.showForm = '1'
      this.dialogVisible = true
    },
    // *删除
    async handleRemoveUser(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('customer_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Customer/del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getCustomerList()
      }
    },
    // *编辑提交
    async handleEditUserSubmit() {
      if (this.editUserForm.customer_name.trim().length <= 0)
        return this.$message.error('请填写客户名称')
      if (this.editUserForm.project_type_id.length <= 0)
        return this.$message.error('请选择业务类型')
      if (!this.editUserForm.type) return this.$message.error('请选择客户类型')
      if (!this.editUserForm.is_company)
        return this.$message.error('请选择客户性质')
      let arr = []
      this.contactsEditList.forEach((item, index) => {
        if (
          !item.name &&
          !item.phone &&
          !item.charege &&
          !item.wx &&
          index != 0
        )
          return
        arr.push(
          item.name + '-' + item.phone + '-' + item.charege + '-' + item.wx
        )
      })
      this.editUserForm.contacts = JSON.stringify(arr)
      // return console.log(this.editUserForm)
      let project_typeStr = ''
      this.editUserForm.project_type_id.forEach((item) => {
        project_typeStr += item + ','
      })
      project_typeStr = project_typeStr.slice(0, project_typeStr.length - 1)
      // return console.log('this.editUserForm.project_type', project_typeStr)

      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('customer_id', this.editId)
        param.append('company_id', this.company_id)
        param.append('customer_name', this.editUserForm.customer_name)
        param.append('project_type', project_typeStr)
        param.append('type', this.editUserForm.type)
        param.append('is_company', this.editUserForm.is_company)
        param.append('source', this.editUserForm.source)
        param.append('describe', this.editUserForm.describe)
        param.append('remark', this.editUserForm.remark)
        param.append('contacts', this.editUserForm.contacts)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Customer/edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getCustomerList()
      }, this.timeDou)
    },
    // *点击编辑成员
    async handleEditUser(row) {
      // this.editUserForm = {}

      this.editName = row.customer_name
      this.editId = row.id
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('customer_id', row.id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Customer/detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.editUserForm = res.datas.info
      console.log('编辑信息', this.editUserForm)
      this.editUserForm.contacts.forEach((item) => {
        this.contactsEditList.push({
          name: item.split('-')[0],
          phone: item.split('-')[1],
          charege: item.split('-')[2],
          wx: item.split('-')[3],
        })
      })
      this.showForm = '2'
      this.dialogVisible = true
    },

    handleClick(tab, event) {
      if (tab.index === '0') {
        this.is_company = '0'
        this.addUserForm.is_company = '0'
        this.currentUserPage = 1
        this.getCustomerList()
      } else if (tab.index === '1') {
        this.is_company = '1'
        this.addUserForm.is_company = '1'
        this.currentUserPage = 1
        this.getCustomerList()
      }
    },
    getId() {
      this.activeName = this.$route.query.type
    },
    // 项目状态选择
    projectTypeSelect(val) {
      if (val === this.searchInfo.projectType) return
      this.searchInfo.projectType = val
      this.getCustomerList()
    },
    // 客户状态选择
    clientStatusSelect(val) {
      if (val === this.searchInfo.clientStatus) return
      this.searchInfo.clientStatus = val
      this.getCustomerList()
    },
    // 开始日期选择器
    startChange() {
      if (this.searchInfo.startDate == null) {
        this.searchInfo.startDate = ''
      }
      if (this.searchInfo.endDate == null) {
        this.searchInfo.endDate = ''
      }
      this.getList()
    },
    // 结束日期选择器
    endChange() {
      if (this.searchInfo.startDate == null) {
        this.searchInfo.startDate = ''
      }
      if (this.searchInfo.endDate == null) {
        this.searchInfo.endDate = ''
      }
      this.getList()
    },
    getList() {},
    handleUserSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleUserCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.editName = ''
      this.editId = ''
      this.contactsEditList = []
      this.addUserForm = {
        customer_name: '',
        project_type: [],
        type: '0',
        is_company: '0',
        source: '',
        describe: '',
        remark: '',
        contacts: '',
      }
      this.contactsList = [
        {
          name: '',
          phone: '',
          charege: '',
          wx: '',
        },
      ]
    },
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.activeName = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    if (!this.company_id) {
      this.$message.error('请重新选择您要进入的企业')
      this.$router.push('/join')
    }
    this.getProjectTypeList()
    this.getCustomerList()
  },
  watch: {
    $route: 'getId',
  },
}
</script>
<style lang="less" scoped>
#clientManage {
  /deep/.el-table {
    // shao减50
    height: calc(100% - 20px - 172px - 10px - 48px - 10px - 3px);
    .el-table__body-wrapper {
      height: calc(100% - 62px);
      overflow-y: auto;
    }
  }
  .contactsBox {
    max-height: 120px;
    overflow-y: auto;
  }
  .firstItemNeedMargin {
    margin-top: 0px !important;
  }
  .AddLianxiRen {
    color: #128bf1;
    border-color: #40a0f2;
    width: 110px;
    height: 30px;
    padding: 0;
    justify-content: center;

    align-items: center;
    border-radius: 15px;
  }
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;

  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索条件行
    .searchInfoRow {
      border: 1px solid #efefef;
      padding-top: 20px;
      box-sizing: border-box;
      margin-bottom: 10px;
      .SearchFormRow {
        /deep/.el-form-item {
          width: 100% !important;
          display: flex;
          align-items: center;
        }
        /deep/.el-form-item__label {
          box-sizing: border-box;
          font-size: 18px;
          line-height: 40px;
          padding-left: 2% !important;
        }
        /deep/.el-form-item__content {
          width: 70%;
          margin-left: 0 !important;
        }
      }
      .firstRow {
        display: flex;
        // (deep)
        .el-form-item {
          width: 38%;
          margin-right: 4%;
          /deep/.el-form-item__label {
            box-sizing: border-box;
            font-size: 18px;
            padding-left: 5%;
            padding-right: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 48px;
          }
        }
        /deep/.el-form-item__content {
          display: flex;
        }
        /deep/.SearchDate {
          .el-input__inner {
            line-height: 45px;
            font-size: 16px;
            height: 45px;
            width: 100%;
            color: #333;
            &::placeholder {
              color: #333;
            }

            &::-webkit-input-placeholder {
              /* WebKit browsers 适配谷歌 */
              color: #333;
            }

            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 适配火狐 */
              color: #333;
            }
          }
        }
        /deep/.el-input__inner {
          line-height: 45px;
          font-size: 16px;
          height: 45px;
          width: 80%;
          color: #333;
          &::placeholder {
            color: #333;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #333;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #333;
          }
        }
        .projectType {
          display: flex;
          height: 100%;
          width: 100%;
          align-items: center;
          li {
            width: 20%;

            span {
              display: inline-block;
              text-align: center;
              cursor: pointer;
              font-size: 16px;
              height: 32px;
              line-height: 32px;
              padding: 0 20px;
            }
          }
          .liActive {
            border-radius: 15px;
            color: #128bf1;
            background-color: #d1eaff;
          }
        }
      }
    }
    // 按钮操作行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .leftCol {
        p {
          width: 100px;
          padding-left: 30px;
          font-size: 18px;
          color: #333;
          span {
            color: #128bf1;
          }
        }
        /deep/.el-button {
          width: inherit !important;
          padding: 0 30px !important;
          color: #128bf1 !important;
          background-color: #fff !important;
          border: 1px solid #40a0f2 !important;
        }
      }
      /deep/.tableSearch {
        width: 28%;
        /deep/.el-input__inner {
          height: 48px;
          border-radius: 24px;
          font-size: 16px;
          border: none;
          background-color: #f4f5f6;
        }
      }
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
      }
    }
    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 40px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 180px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 10px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }
  /deep/.el-form-item {
    margin-bottom: 5px;
  }
  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 40px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    // display: flex;
    /deep/.el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: 18px;
      }
    }
    .el-input__inner {
      font-size: inherit;
      width: 80%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 70px;
        font-size: inherit;
        resize: none;
        border-radius: 0;
        font-family: Microsoft YaHei;
      }
    }
    .el-radio-group {
      height: 35px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        // margin-right: 15%;
        width: 20%;
      }
      .el-radio__input {
        width: 16px;
        height: 16px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 16px;
      }
    }
  }
  .diaForm_box {
    width: 100%;
    padding-left: 50px;
    box-sizing: border-box;
    /deep/.labelFormItem {
      /deep/.ProjectType {
        width: 80%;
        flex-wrap: wrap;
        height: initial;
        max-height: 105px;
        overflow-y: auto;
        /deep/.el-radio {
          // width: 30%;
          height: 35px;
        }
        /deep/.el-checkbox {
          width: 20%;
          .el-checkbox__label {
            font-size: 16px;
            font-weight: normal;
          }
        }
      }
      /deep/.el-form-item__label {
        line-height: 36px;
      }
    }
    .inputTwoRow {
      box-sizing: border-box;
      padding: 0 16%;
      padding-right: 14%;
      width: 100%;
      display: flex;
      /deep/.el-input__inner {
        width: 100%;
      }
    }
    .diaFormTitle {
      width: 100%;
      font-weight: bold;
      color: #128bf1;
      font-size: 18px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .diaFormTitle::before {
      content: '';
      display: block;
      width: 3px;
      height: 16px;
      background-color: #40a0f2;
      margin-right: 5px;
    }
    .diaFormTitle1 {
      width: 100%;
      font-weight: bold;
      color: #128bf1;
      font-size: 18px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .diaFormTitle1 span {
      display: flex;
      align-items: center;
    }
    .diaFormTitle1 span::before {
      content: '';
      display: block;
      width: 3px;
      height: 16px;
      background-color: #40a0f2;
      margin-right: 5px;
    }
  }

  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
}
.addClientDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 3vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
    .el-dialog__footer {
      padding-bottom: 10px;
      // color: ;
    }
  }
}
/deep/.heightAutoC {
  // max-height: 305px;
  // overflow-y: auto;
}
</style>